import "../scss/style.scss";

// JS Components
import "./scripts/_audio.js";
import "./scripts/_burger.js";
import "./scripts/_counter.js";
import "./scripts/_label.js";
import "./scripts/_lang.js";
import "./scripts/_navbar.js";
import "./pages/contact.js";

import AOS from 'aos';

document.addEventListener("DOMContentLoaded", function () {
    var isDesktop = window.innerWidth > 767;

    AOS.init({
        offset: 200,
        duration: 600,
        easing: 'ease-in-out',
        once: true,
        anchorPlacement: 'top-bottom'
    });

    window.addEventListener('resize', () => {
        const nowDesktop = window.innerWidth > 767;
        if (nowDesktop !== isDesktop) {
            isDesktop = nowDesktop;
            AOS.refreshHard();
        }
    });

    // Refresh AOS
    const refreshAosTriggers = document.querySelectorAll('.js-aos-refresh');
    for (const refreshAosTrigger of refreshAosTriggers) {
        refreshAosTrigger.addEventListener('click', () => {
            AOS.refresh();
        });
    }

});